import React from 'react';
import type { Review } from '@noths/polaris-design-system-ooux-interfaces';

import { REVIEWER_LOCATION_FALLBACK, REVIEWER_NAME_FALLBACK } from './copy';
import * as styles from './ReviewCardReviewer.styles';

interface ReviewCardReviewerProps {
  reviewer: Review['reviewer'];
}

/**
 * Who left the review: their own name and location where the review has them, and trust
 * copy where it does not.
 *
 * Each half falls back on its own, since a review can arrive with one and not the other.
 * `||` rather than `??` so an empty string, which a service sends as readily as it omits
 * a field, falls back too instead of leaving the footer half blank.
 *
 * Its own component because `ReviewCard` and `ReviewPreviewCard` show the same footer,
 * and two copies of a fallback rule are two chances for it to drift.
 */
export const ReviewCardReviewer = ({ reviewer }: ReviewCardReviewerProps) => (
  <p css={styles.reviewer}>
    <span css={styles.name}>{reviewer?.name || REVIEWER_NAME_FALLBACK}</span>
    <span css={styles.location}>{reviewer?.location || REVIEWER_LOCATION_FALLBACK}</span>
  </p>
);

ReviewCardReviewer.displayName = 'ReviewCardReviewer';
